/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */

/**
 * A message that a broker passes around
 */
class Message<T> {
  topicPaths: string;
  type: string;
  data: T;
  createdTime: number;

  constructor(topicPaths: string, type: string, data: T) {
    this.topicPaths = topicPaths;
    this.type = type;
    this.data = data;
    this.createdTime = Date.now();
  }
}

export default Message;
